/* eslint-disable no-undef */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './ProviderPageLeftPart.sass';
import { Modal } from 'react-bootstrap';
import teamImage from '../../../../../assets/images/matchoffice_team.jpg';
import SignUpFormModal from '../../SharedComponents/SignUpFormModal/SignUpFormModal';

class ProviderPageLeftPart extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showModal: false,
    };

    this.handleShow = this.handleShow.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  handleShow() {
    this.setState({ showModal: true });
  }

  handleClose() {
    this.setState({ showModal: false });
  }

  render() {
    const { signup } = this.props.urls;
    const { formAuthToken, formPostUrl } = this.props;

    return (
      <div>
        <div className="col-md-9 provider-content">
          <div dangerouslySetInnerHTML={{ __html: I18n.t('provider_signup.page.intro') }} />
          <ul className="provider-content__provider-advantage">
            <li>{I18n.t('provider_signup.page.advantage_1')}</li>
            <li>{I18n.t('provider_signup.page.advantage_2')}</li>
            <li>{I18n.t('provider_signup.page.advantage_3')}</li>
            <li>{I18n.t('provider_signup.page.advantage_4')}</li>
          </ul>

          <hr />

          <div dangerouslySetInnerHTML={{ __html: I18n.t('provider_signup.page.terms_of_payment') }} />
          <button className="button--blue" type="button" onClick={this.handleShow}>
            {I18n.t('provider_signup.page.became_provider_button')}
          </button>
          <Modal
            className="sign-up-form-modal"
            show={this.state.showModal}
            onHide={this.handleClose}
            backdrop="static"
          >
            <Modal.Body>
              <button type="button" className="close" onClick={this.handleClose}>&nbsp;</button>
              <SignUpFormModal signUpPath={formPostUrl} color formAuthToken={formAuthToken} />
            </Modal.Body>
          </Modal>

          <hr />

          <div className="row">
            <div className="col-sm-6">
              <div className="team-image-wrapper">
                <img src={teamImage} alt="Matchoffice team" title="Matchoffice team" />
              </div>
            </div>
            <div
              className="col-sm-6"
              dangerouslySetInnerHTML={{ __html: I18n.t('provider_signup.page.about_matchoffice') }}
            />
          </div>

          <hr />

          <div className="row">
            <div className="col-md-12">
              <div dangerouslySetInnerHTML={{ __html: I18n.t('provider_signup.page.contacts') }} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

ProviderPageLeftPart.propTypes = {
  urls: PropTypes.oneOfType([PropTypes.object]),
  formAuthToken: PropTypes.string,
};

ProviderPageLeftPart.defaultProps = {
  urls: {},
  formAuthToken: '',
};

export default ProviderPageLeftPart;
